import { Instagram } from "lucide-react";

const team = [
  {
    name: "Ria Bhardwaj",
    role: "Director of Operations",
    img: `${process.env.PUBLIC_URL}/img/team-ria.png`,
    bio: "Ria is passionate about building systems that empower teams, improve performance and support.",
  },
  {
    name: "Sascha",
    role: "Creative Director",
    img: `${process.env.PUBLIC_URL}/img/team-sascha.png`,
    bio: "Sascha brings ideas to life through innovative design, thoughtful strategy, and a deep understanding of our audience.",
  },
];

export default function Team() {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="relative py-24 md:py-32 bg-pearl"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-7">
            <div className="eyebrow mb-5" data-testid="team-eyebrow">
              — The Women Behind The Work
            </div>
            <h2
              className="font-display text-4xl sm:text-5xl lg:text-6xl text-charcoal leading-[1.05]"
              data-testid="team-heading"
            >
              A small, sharp team{" "}
              <span className="italic text-blush">obsessed</span> with your
              growth.
            </h2>
          </div>
          <p
            className="lg:col-span-5 self-start lg:pt-14 text-charcoal/70 text-base leading-relaxed"
            data-testid="team-subtext"
          >
            Strategists, writers, designers and growth marketers — working as
            one in-house creative team for the brands we partner with.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-10 max-w-5xl mx-auto">
          {team.map((m) => (
            <article
              key={m.name}
              className="team-card group"
              data-testid={`team-card-${m.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="photo aspect-[4/5]">
                <img src={m.img} alt={m.name} />
              </div>
              <div className="p-6 md:p-8">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="font-display text-2xl md:text-3xl text-charcoal leading-tight">
                      {m.name}
                    </h3>
                    <div className="text-xs uppercase tracking-[0.18em] text-charcoal/55 mt-2">
                      {m.role}
                    </div>
                  </div>
                </div>
                <p className="mt-4 text-base text-charcoal/70 leading-relaxed">
                  {m.bio}
                </p>
                <div className="mt-5 flex items-center gap-3 text-charcoal/50">
                  <a
                    href="#"
                    aria-label="Instagram"
                    className="hover:text-lilac transition-colors"
                    data-testid={`team-${m.name.toLowerCase().replace(/\s+/g, "-")}-instagram`}
                  >
                    <Instagram size={18} />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
